import React from 'react';
import { Link } from 'react-router-dom';
import '../css/jobApplicationChoice.css';

const JobApplicationChoice = () => {
  return (
    <div className="job-application-page">
      <div className="job-header">
        <p>Applying for</p>
        <h1>Senior Consultant - .NET Technical lead</h1>
        <h2>Consultant</h2>
      </div>

      <div className="job-options">
        <div className="job-card">
          <p className="job-label">I have an account</p>
          <Link to="/login" className="job-btn">Login</Link>
        </div>

        <div className="job-card">
          <p className="job-label">I am applying for the first time</p>
          <Link to="/multistep" className="job-btn">Apply </Link>
        </div>
      </div>
    </div>
  );
};

export default JobApplicationChoice;


